// core version + navigation, pagination modules:
import Swiper, { Pagination, Autoplay, EffectFade } from 'swiper';
// import Swiper and modules styles
import 'swiper/css/autoplay';
import 'swiper/css/effect-fade';	

function testimonialSlider() {
  // init Swiper:
  var init = false;

  if (window.innerWidth >= 768) {
    if (!init) {
      init = true;

      const swiper = new Swiper(".testimonial-slider", {
        modules: [Pagination, Autoplay, EffectFade],
        loop: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        slidesPerView: 1,
        slidesPerGroup: 1,
        slidesPerColumn: 1,
        spaceBetween: 100,
        speed: 1000,
        breakpoints: {
          // md
          728: {
            slidesPerView: 1,
            slidesPerGroup: 1,
            slidesPerColumn: 1,
          },
        },
      });
    }
  } else if (init) {
    swiper.destroy();

    init = false;
  }
}
testimonialSlider();
window.addEventListener("resize", testimonialSlider);

export default testimonialSlider;
